import * as Account_en from './Account.en.js';
import * as Account_es from './Account.es.js';

const AccountTuple = [
  { type: 'Account', language: 'en', object: Account_en.default },
  { type: 'Account', language: 'es', object: Account_es.default },
];

export default AccountTuple;
